export const categories = [
  {
    slug: 'xiazai-jiaocheng',
    name: '下载教程',
    description: '黄瓜视频App各平台下载安装详细指南',
    icon: 'ri-download-2-line',
    articleCount: 12,
  },
  {
    slug: 'shiyong-jiqiao',
    name: '使用技巧',
    description: '掌握黄瓜视频App的隐藏功能与高效使用方法',
    icon: 'ri-lightbulb-line',
    articleCount: 18,
  },
  {
    slug: 'gongneng-jieshao',
    name: '功能解读',
    description: '深入了解黄瓜视频App各项核心功能特性',
    icon: 'ri-apps-2-line',
    articleCount: 15,
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '汇总用户最常遇到的疑问及详细解答',
    icon: 'ri-question-answer-line',
    articleCount: 22,
  },
  {
    slug: 'xinban-gengxin',
    name: '版本更新',
    description: '黄瓜视频App各版本更新日志与新功能一览',
    icon: 'ri-refresh-line',
    articleCount: 8,
  },
  {
    slug: 'anquan-yinsi',
    name: '安全隐私',
    description: '了解黄瓜视频App的隐私保护与安全机制',
    icon: 'ri-shield-check-line',
    articleCount: 6,
  },
];

export const features = [
  {
    icon: 'ri-smartphone-line',
    title: '海量原创内容',
    description: '汇聚来自全球创作者的原创短视频，涵盖搞笑、美食、音乐、舞蹈、旅行、科技等数十个品类，每天都有新鲜内容持续更新。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅播放体验',
    description: '采用先进的视频压缩与CDN加速技术，无论4G还是WiFi环境，都能享受秒开无卡顿的极致播放体验。',
  },
  {
    icon: 'ri-brush-2-line',
    title: '智能推荐算法',
    description: '基于深度学习的内容推荐系统，精准分析您的观看偏好，为您量身打造专属内容流，越用越懂你。',
  },
  {
    icon: 'ri-tools-line',
    title: '强大创作工具',
    description: '内置一键美颜、滤镜特效、音乐配乐、文字贴纸等专业视频编辑功能，零基础也能轻松创作出优质短视频。',
  },
  {
    icon: 'ri-shield-flash-line',
    title: '青少年保护模式',
    description: '完善的青少年模式，支持时长限制、内容过滤、护眼提醒，为未成年人提供安全健康的观看环境。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '活跃社区互动',
    description: '支持点赞、评论、分享、私信等多种互动方式，与创作者零距离交流，打造温暖有爱的社区氛围。',
  },
];

export const hotArticles = [
  {
    id: 1,
    title: '黄瓜视频App最新版本下载安装完整教程（2026年）',
    excerpt: '本文详细介绍黄瓜视频App在iOS和Android平台的最新版本下载与安装步骤，附带常见安装问题解决方案，助您3分钟内成功安装。',
    category: '下载教程',
    categorySlug: 'xiazai-jiaocheng',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20vibrant%20short%20video%20app%20interface%20with%20colorful%20content%20feed%2C%20clean%20minimal%20background%20with%20soft%20warm%20lighting%2C%20product%20photography%20style%2C%20bright%20and%20energetic%20aestheticwith%20fresh%20green%20accents&width=800&height=450&seq=article-cover-1&orientation=landscape',
    date: '2026-08-01',
    readTime: '8分钟',
    featured: true,
  },
  {
    id: 2,
    title: '黄瓜视频App十大隐藏功能，90%的用户都不知道',
    excerpt: '从手势快捷操作到智能省流模式，揭秘黄瓜视频App那些鲜为人知的实用功能，让你的使用体验再上一个台阶。',
    category: '使用技巧',
    categorySlug: 'shiyong-jiqiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20with%20glowing%20app%20icons%20and%20hidden%20feature%20hints%20floating%20around%20it%2C%20mysterious%20and%20techy%20vibe%2C%20dark%20background%20with%20green%20glow%20accents%2C%20digital%20illustration%20style%2C%20clean%20composition&width=800&height=450&seq=article-cover-2&orientation=landscape',
    date: '2026-07-28',
    readTime: '12分钟',
    featured: true,
  },
  {
    id: 3,
    title: '新手必看：黄瓜视频App从注册到发布第一条视频全流程',
    excerpt: '面向零基础新用户的完整入门指南，涵盖账号注册、个人资料设置、内容浏览、视频拍摄与发布的每一个步骤。',
    category: '使用技巧',
    categorySlug: 'shiyong-jiqiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beginner%20friendly%20smartphone%20screen%20showing%20a%20step%20by%20step%20registration%20process%20for%20a%20video%20app%2C%20warm%20inviting%20colors%2C%20clean%20interface%20design%2C%20soft%20natural%20lighting%2C%20friendly%20and%20approachable%20aesthetic&width=800&height=450&seq=article-cover-3&orientation=landscape',
    date: '2026-07-25',
    readTime: '10分钟',
    featured: false,
  },
  {
    id: 4,
    title: '黄瓜视频App安卓版无法安装？六种解决方案汇总',
    excerpt: '针对安卓用户常见的安装失败、解析包错误、空间不足等问题，提供六种经过验证的解决方案，总有一种适合你。',
    category: '常见问题',
    categorySlug: 'changjian-wenti',
    coverImage: 'https://readdy.ai/api/search-image?query=Android%20phone%20screen%20showing%20an%20app%20installation%20error%20message%20with%20a%20troubleshooting%20guide%20overlay%2C%20tech%20support%20concept%2C%20clean%20modern%20design%2C%20warm%20amber%20and%20green%20color%20scheme&width=800&height=450&seq=article-cover-4&orientation=landscape',
    date: '2026-07-20',
    readTime: '6分钟',
    featured: false,
  },
  {
    id: 5,
    title: '黄瓜视频App v5.8.0版本更新：全新界面与AI创作助手上线',
    excerpt: '最新版本带来了全面焕新的UI设计、AI智能剪辑助手、画质增强引擎等重磅功能，详细解读本次更新的所有亮点。',
    category: '版本更新',
    categorySlug: 'xinban-gengxin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20freshly%20updated%20modern%20video%20app%20interface%20with%20AI%20features%20highlighted%2C%20futuristic%20yet%20warm%20design%2C%20clean%20white%20background%20with%20green%20and%20orange%20accent%20elements%2C%20product%20showcase%20style&width=800&height=450&seq=article-cover-5&orientation=landscape',
    date: '2026-07-15',
    readTime: '7分钟',
    featured: false,
  },
  {
    id: 6,
    title: '黄瓜视频App隐私设置详解：保护你的个人信息安全',
    excerpt: '全面解析黄瓜视频App的隐私保护机制，教你如何正确设置账号隐私、管理数据权限、开启安全防护，让使用更安心。',
    category: '安全隐私',
    categorySlug: 'anquan-yinsi',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20privacy%20protection%20shield%20icon%20with%20lock%20symbol%2C%20digital%20security%20concept%2C%20clean%20professional%20design%2C%20soft%20green%20gradient%20background%2C%20trustworthy%20and%20reliable%20aesthetic&width=800&height=450&seq=article-cover-6&orientation=landscape',
    date: '2026-07-10',
    readTime: '9分钟',
    featured: false,
  },
];

export const faqs = [
  {
    question: '黄瓜视频App在哪里可以下载？',
    answer: '黄瓜视频App可通过官方网站（本页面提供下载入口）、苹果App Store、以及主流安卓应用市场（华为应用市场、小米应用商店、应用宝等）进行下载。建议优先通过官方渠道下载，以确保获得最新版本和安全保障。',
  },
  {
    question: '黄瓜视频App是否免费使用？',
    answer: '黄瓜视频App基础功能完全免费，包括浏览视频、点赞评论、关注创作者等核心功能。部分高级创作工具和专属内容可能需要订阅会员服务，但不会影响正常的观看体验。',
  },
  {
    question: '如何注册黄瓜视频App账号？',
    answer: '打开App后点击"我的"-"注册/登录"，支持手机号一键注册、微信授权登录、Apple ID登录（iOS）等多种方式。注册过程仅需30秒，完成后即可完整使用所有功能。',
  },
  {
    question: '黄瓜视频App支持哪些设备？',
    answer: '黄瓜视频App目前支持iOS 13.0及以上版本的iPhone设备，以及Android 8.0及以上版本的安卓手机和平板设备。iPad和安卓平板可获得适配的大屏体验。',
  },
  {
    question: '下载的视频可以离线观看吗？',
    answer: '可以。黄瓜视频App支持视频离线缓存功能，在WiFi环境下将喜欢的视频下载到本地，随时随地离线观看，不消耗移动数据流量。缓存视频可在"我的-离线缓存"中管理。',
  },
  {
    question: '遇到播放卡顿怎么办？',
    answer: '如果遇到播放卡顿，建议依次尝试以下操作：1）检查网络连接，切换WiFi/4G；2）在App设置中降低默认画质；3）清理App缓存（我的-设置-清理缓存）；4）重启App；5）更新至最新版本。通常前两步即可解决大部分卡顿问题。',
  },
  {
    question: '如何联系黄瓜视频App客服？',
    answer: '您可以通过以下方式联系客服：1）App内"我的-帮助与反馈-在线客服"；2）发送邮件至官方客服邮箱；3）关注官方微信公众号留言。我们的客服团队将在24小时内为您处理问题。',
  },
  {
    question: '黄瓜视频App是否安全？会泄露个人隐私吗？',
    answer: '黄瓜视频App高度重视用户隐私安全。我们采用银行级数据加密技术，严格遵守个人信息保护相关法律法规，不会未经授权向第三方提供用户数据。您可以在"设置-隐私设置"中自主管理各项权限。',
  },
];

export const downloadLinks = {
  ios: 'https://apps.apple.com/app/huanggua-video',
  android: 'https://www.example.com/download/android',
  androidApk: 'https://www.example.com/download/apk',
};

export const testimonials = [
  {
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20friendly%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20warm%20lighting&width=100&height=100&seq=avatar-1&orientation=squarish',
    role: '资深用户 · 使用2年',
    content: '从第一版就在用黄瓜视频，内容质量一直很稳定。推荐算法越来越精准，推送的基本都是我感兴趣的内容，每天刷半个小时刚刚好。',
    rating: 5,
  },
  {
    name: '阿花',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20warm%20genuine%20smile%2C%20modern%20casual%20look%2C%20clean%20light%20background%2C%20natural%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-2&orientation=squarish',
    role: '内容创作者 · 粉丝5.2万',
    content: '作为一个创作者，黄瓜视频的创作工具真的太好用了！AI剪辑功能帮我节省了大量时间，画质优化后视频质感提升明显，粉丝增长也快了。',
    rating: 5,
  },
  {
    name: '老王',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20with%20kind%20expression%2C%20casual%20business%20style%2C%20clean%20background%2C%20warm%20and%20trustworthy%20vibe%2C%20professional%20headshot&width=100&height=100&seq=avatar-3&orientation=squarish',
    role: '普通用户 · 使用1年',
    content: '儿子推荐给我的，一开始觉得短视频就是年轻人玩的，没想到内容很丰富，美食、旅游、养生啥都有，现在我和老伴每天都要刷一刷。',
    rating: 4,
  },
];

export const aboutInfo = {
  brandName: '黄瓜视频',
  slogan: '记录美好，分享快乐',
  founded: '2022年',
  users: '5000万+',
  description: '黄瓜视频成立于2022年，是一家专注于短视频领域的互联网科技公司。我们致力于通过技术创新，为全球用户提供优质、多元、有趣的短视频内容体验。经过数年发展，黄瓜视频已成为国内领先的短视频平台之一，累计服务超过5000万用户。',
  mission: '用科技让每个人的生活更有趣',
  vision: '成为全球最受欢迎的短视频社区平台',
  values: ['用户至上', '创新驱动', '内容为王', '开放共赢', '社会责任'],
  contact: {
    email: 'support@huanggua-video.com',
    wechat: 'huanggua_official',
    weibo: '@黄瓜视频官方',
    address: '北京市朝阳区望京科技园',
  },
};